// The core speaks exactly one bbox dialect: [x, y, width, height] in the
// source image's own pixel coordinates. Adapters convert on the way in --
// deliberately, so the panel never carries a format flag. (toseftasite's
// emitted JSON stores [x0, y0, x1, y1]; taanticMidrashimDig's stores
// [x, y, w, h] already.)

export function fromXYXY(b) {
    if (!b || b.length < 4) return null;
    const [x0, y0, x1, y1] = b;
    return [x0, y0, x1 - x0, y1 - y0];
}

export function fromXYWH(b) {
    if (!b || b.length < 4) return null;
    return [b[0], b[1], b[2], b[3]];
}

// Percentage geometry for absolutely positioning the highlight over a
// percentage-sized image. Percentages (rather than pixels) are what let the
// zoom implementation resize the wrapper and have the box follow for free.
export function toPercentStyle(bbox, page) {
    if (!bbox || !page || !page.width || !page.height) return null;
    return {
        left: (bbox[0] / page.width * 100) + '%',
        top: (bbox[1] / page.height * 100) + '%',
        width: (bbox[2] / page.width * 100) + '%',
        height: (bbox[3] / page.height * 100) + '%',
    };
}
